import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'tr-wrapper-layout',
  templateUrl: './wrapper-layout.component.html',
  //styleUrls: ['./wrapper-layout.component.scss']
})
export class WrapperLayoutComponent implements OnInit {
  @Input() showNavigation: boolean = true;
  @Input() showLoginImage: boolean = true;
  @Input() currentSelected: number = 0;
  @Output() showContent = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }
  
  onContentShown(tabIndex: number): void {
    this.showContent.emit(tabIndex);
  }

}



// WEBPACK FOOTER //
// ./src/app/authentication/components/wrapper-layout/wrapper-layout.component.ts